import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { orderBy, sortBy } from 'lodash-es';
import { Typography } from 'seagull';
import { getAccountingDetails } from '../accounting.utils';
import styles from './MapContactsModal.module.scss';
import { getContactMapStatus } from './MapContactsRow';
export var ContentState = /*#__PURE__*/ function(ContentState) {
    ContentState["Loading"] = "loading";
    ContentState["Empty"] = "empty";
    ContentState["Error"] = "error";
    ContentState["Valid"] = "valid";
    return ContentState;
}({});
export var FooterState = /*#__PURE__*/ function(FooterState) {
    FooterState["Valid"] = "valid";
    FooterState["Invalid"] = "invalid";
    return FooterState;
}({});
export const columnDefs = [
    {
        width: 400
    },
    {
        width: 400
    },
    {
        width: [
            200,
            260
        ]
    }
];
export const getHeaderItems = (accounting)=>[
        {
            value: /*#__PURE__*/ _jsx("div", {
                className: styles.columnHeader,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    children: "Anchor contact"
                })
            })
        },
        {
            value: /*#__PURE__*/ _jsx("div", {
                className: styles.columnHeader,
                children: /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph2",
                    children: [
                        getAccountingDetails(accounting).fullName,
                        " customer"
                    ]
                })
            })
        },
        {
            value: 'Status'
        }
    ];
export var AccountingCustomersDropdownOptionType = /*#__PURE__*/ function(AccountingCustomersDropdownOptionType) {
    AccountingCustomersDropdownOptionType["CreateNew"] = "createNew";
    AccountingCustomersDropdownOptionType["Existing"] = "existing";
    return AccountingCustomersDropdownOptionType;
}({});
export var FailureReasons = /*#__PURE__*/ function(FailureReasons) {
    FailureReasons["General"] = "general";
    FailureReasons["DuplicateMapping"] = "duplicateMapping";
    FailureReasons["DuplicateNew"] = "duplicateNew";
    return FailureReasons;
}({});
export function getModalState(contacts, accountingCustomers) {
    if (contacts.error || accountingCustomers.error) {
        return {
            content: "error",
            footer: "invalid"
        };
    } else if (!contacts.data && contacts.loading || !accountingCustomers.data && accountingCustomers.loading) {
        return {
            content: "loading",
            footer: "invalid"
        };
    } else if (contacts.data && accountingCustomers.data) {
        return contacts.data.length === 0 ? {
            content: "empty",
            footer: "invalid"
        } : {
            content: "valid",
            footer: "valid"
        };
    } else {
        return {
            content: "loading",
            footer: "invalid"
        };
    }
}
export function getNumMappedContacts(contacts, accounting, accountingCustomers) {
    if (!accountingCustomers) {
        return 0;
    }
    return contacts.filter((c)=>getContactMapStatus(c, accounting, accountingCustomers) === 'mapped').length;
}
export function getRelevantSortedContacts(contacts, contactIds, accounting) {
    if (!contacts) {
        return [];
    }
    const filtered = contacts.filter((c)=>(!contactIds.length || contactIds.includes(c.id())) && !c.isSample());
    const orderedByName = orderBy(filtered, [
        (c)=>c.firstName(),
        (c)=>c.lastName(),
        (c)=>c.companyName()
    ], [
        'asc',
        'asc',
        'asc'
    ]);
    return sortBy(orderedByName, (c)=>!!c.integratedId({
            accounting
        }));
}
export function applyFilters(contacts, search, contactMappingStatusFilter, accounting, accountingCustomers) {
    const searchFiltered = contacts.filter((c)=>applySearch(search, c));
    const contactMappingStatusFilterOptions = getContactMappingStatusFilterOptions(searchFiltered, accounting, accountingCustomers);
    const filteredAnchorContacts = searchFiltered.filter((c)=>applyContactMappingStatusFilter(contactMappingStatusFilter, c, accounting, accountingCustomers));
    return {
        filteredAnchorContacts,
        contactMappingStatusFilterOptions
    };
}
function getContactMappingStatusFilterOptions(contacts, accounting, accountingCustomers) {
    const mappedCount = contacts.filter((c)=>getContactMapStatus(c, accounting, accountingCustomers) === 'mapped').length;
    const notMappedCount = contacts.filter((c)=>getContactMapStatus(c, accounting, accountingCustomers) === 'notMapped').length;
    const failedToMapCount = contacts.filter((c)=>getContactMapStatus(c, accounting, accountingCustomers) === 'failedToMap').length;
    const options = [];
    if (mappedCount > 0) {
        options.push({
            value: 'mapped',
            counter: mappedCount,
            label: 'Yes'
        });
    }
    const noCount = notMappedCount + failedToMapCount;
    if (noCount > 0) {
        options.push({
            value: 'notMapped',
            counter: noCount,
            label: 'No'
        });
    }
    return options;
}
function applySearch(search, contact) {
    const normalizedSearch = search ? search.trim().toLowerCase() : search;
    const companyName = contact.companyName().toLowerCase();
    const firstName = contact.firstName().toLowerCase();
    const lastName = contact.lastName().toLowerCase();
    const email = contact.email().toLowerCase();
    return !normalizedSearch || "".concat(companyName, " ").concat(firstName, " ").concat(lastName, " ").concat(email).includes(normalizedSearch);
}
function applyContactMappingStatusFilter(filter, contact, accounting, accountingCustomers) {
    if (filter.length === 0) {
        return true;
    }
    const contactStatus = getContactMapStatus(contact, accounting, accountingCustomers);
    return filter.some((status)=>{
        if (status === 'mapped') {
            return contactStatus === 'mapped';
        }
        if (status === 'notMapped') {
            return contactStatus === 'notMapped' || contactStatus === 'failedToMap';
        }
        return status === contactStatus;
    });
}
